import { littaApiFetchJson } from '@/lib/api/litta-api-fetch'
import {
    ListJobStatusesResponseSchema,
    ReconcileJobWorkflowResponseSchema,
    type JobStatusRow,
    type ReconcileJobWorkflowResponse,
} from '@/schemas/jobs/schema'

export async function fetchJobStatusesFromApi(): Promise<JobStatusRow[]> {
    const data = await littaApiFetchJson<unknown>('/jobs/statuses')
    const parsed = ListJobStatusesResponseSchema.parse(data)
    return parsed.statuses
}

export interface ReconcileJobWorkflowParams {
    bookOrderId: string
    statusKey: string
    expectedStatusKey: string
    reason: string
    clearStepData?: boolean
}

export async function reconcileJobWorkflow(
    params: ReconcileJobWorkflowParams,
): Promise<ReconcileJobWorkflowResponse> {
    const { bookOrderId, ...body } = params
    const data = await littaApiFetchJson<unknown>(
        `/jobs/${encodeURIComponent(bookOrderId)}/workflow`,
        {
            method: 'PATCH',
            body: JSON.stringify(body),
        },
    )
    return ReconcileJobWorkflowResponseSchema.parse(data)
}
